import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaGraduationCap, FaCertificate, FaEllipsisH } from "react-icons/fa";

import { styles } from "../styles";
import { certifications } from "../constants";
import { SectionWrapper } from "../hoc";
import { fadeIn, textVariant } from "../utils/motion";

const featuredCerts = certifications.filter((c) => c.featured);
// On mobile: degree + 2 certs (3 total), on desktop: all featured
const mobileCerts = [
  ...featuredCerts.filter((c) => c.type === "degree"),
  ...featuredCerts.filter((c) => c.type !== "degree").slice(0, 2),
];

const CertificationCard = ({ index, title, institution, type }) => (
  <motion.div
    variants={fadeIn("up", "spring", index * 0.2, 0.75)}
    className={`${
      type === "degree"
        ? "glass glass-card glass-surface-tertiary glass-highlight sm:col-span-2 lg:col-span-3"
        : "glass glass-card glass-surface-tertiary"
    } p-5 rounded-2xl flex items-center gap-4`}
  >
    {type === "degree" ? (
      <FaGraduationCap className="w-10 h-10 text-[#1582C7] flex-shrink-0" />
    ) : (
      <FaCertificate className="w-8 h-8 text-[#1582C7] flex-shrink-0" />
    )}
    <div>
      <h3
        className={`text-foreground font-bold ${
          type === "degree" ? "text-[18px]" : "text-[15px]"
        }`}
      >
        {title}
      </h3>
      <p className="text-secondary text-[13px]">{institution}</p>
    </div>
  </motion.div>
);

const MoreCard = ({ index, remainingCount }) => (
  <motion.div
    variants={fadeIn("up", "spring", index * 0.2, 0.75)}
  >
    <Link
      to="/certificaciones"
      className="glass glass-card glass-surface-tertiary p-5 rounded-2xl flex items-center gap-4 h-full border border-white/10 hover:border-[#1582C7] transition-colors duration-300"
    >
      <FaEllipsisH className="w-8 h-8 text-[#1582C7] flex-shrink-0" />
      <div>
        <h3 className="text-foreground font-bold text-[15px]">
          {remainingCount} certificaciones más
        </h3>
        <p className="text-secondary text-[13px]">Ver todas</p>
      </div>
    </Link>
  </motion.div>
);

const CertificationsSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const visibleCerts = isMobile ? mobileCerts : featuredCerts;
  const remainingCount = certifications.length - visibleCerts.length;

  return (
    <>
      <motion.div variants={textVariant()}>
        <p className={`${styles.sectionSubText} cursor-default`}>
          Formación académica
        </p>
        <h2 className={`${styles.sectionHeadText} cursor-default`}>
          Certificaciones
        </h2>
      </motion.div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {visibleCerts.map((cert, index) => (
          <CertificationCard key={`cert-${index}`} index={index} {...cert} />
        ))}
        <MoreCard index={visibleCerts.length} remainingCount={remainingCount} />
      </div>

      <div className="mt-10 flex justify-center">
        <Link
          to="/certificaciones"
          className="bg-tertiary text-foreground font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-xl hover:bg-sky-700 hover:text-white transition-all duration-300 ease-in-out"
        >
          Ver todas las certificaciones
        </Link>
      </div>
    </>
  );
};

const Certifications = SectionWrapper(
  CertificationsSection,
  "certificaciones",
  0.1
);
export default Certifications;
